import React from "react";

const DevLog2 = React.forwardRef((props, ref) => {
  const heading = "Welcome to the Overworld!";
  const date = "14th February 2022";
  return (
    <div ref={ref}>
      {/* // ! Do not change positions */}
      <h1>{heading}</h1>
      <h4>{date}</h4>
      <div>
        <p>
          <strong>
            Hello everyone and welcome to our third Discovery Log!
          </strong>
        </p>
        <br />
        <div>
          <p>
            In our last Discovery Log, we've emphasized that cooperative
            teamwork gameplay was a major focus for what we wanted Project
            Steelwalker to be, however you would be mistaken if you thought that
            it was our only major focus. In this week's Discovery Log, we'll be
            taking a look at a level that plays into another major aspect of the
            game. Open world environments.
          </p>
          <br />
          <p>
            There is no greater feeling in many adventure games than coming
            across a large open area and exploring the wonders that await within
            it. Our team wanted to replicate that feeling in Project Steelwalker
            while at the same time communicating the backstory of the game
            through visuals.
          </p>
          <br />
          <p>
            The level currently goes by the name &ldquo;Overworld&rdquo; and its
            intention is to give an open space for players to explore in between
            two linear levels that the Overworld is linked to as well as letting
            players get a sense of what the world the game takes place in is
            like. The Overworld level was put together by our level designer,
            Donovan De Carle and our talented group of artists. Take a moment to
            gander at some of the key features in the level.
          </p>
          <br />
          <p>
            Here is a waterfall and river stream that runs through the entire
            map. It is all procedurally generated and was put together through
            blueprints by Hamidreza Ghasemi.
          </p>
          <br />
          <video
            src="../logImages/log3/Log3Video.mp4"
            controls
            autoPlay
            loop
          ></video>
          <p>
            Wandering around the map, you may find many broken down mechanical
            structures and debris. What were they from? Where did they come
            from? What exactly happened here? That is a mystery to be solved in
            Project Steelwalker. These structures were modeled by Nathan
            Sherwood and textured by Richard Hillsdon.
          </p>
          <p>
            <img
              src="https://lh5.googleusercontent.com/u2T958B_gKq0tpN_6TR-jddzlrL5wl-gknbWbMHyJ454pro4OyoATAMUwnnJ9UeSoVNPUijotaYJTEry286Ghd0jMHt0MY1s_9XzKO27X41mL8Qm2jR_eqITFR21xIxEEbRSb8q0"
              alt=""
              width="624"
              height="285"
            />
          </p>
          <p>
            <img
              src="https://lh3.googleusercontent.com/f6rrTCZSx_qPOQiRlSl7ZsfdRdRv3ftiCEjXeyt36Cx4HaeOeoBrfyrYPZJDcUWzbFL8c-NJ5xu2pJ2EllqGMRyZLuW1bRwM0OLryYBrKPRycfJJGamVpsym0380Tae5SZ5DwHN3"
              alt=""
              width="624"
              height="341"
            />
          </p>
          <p>
            Here is a scrolling view from one point in the map. Our team worked
            real hard to ensure that every part of the map is as lively as
            possible.
          </p>
          <br />
          <video
            src="../logImages/log3/Log3Video2.mp4"
            controls
            autoPlay
            loop
          ></video>
          <p>
            Despite everything that you see in this area, don&rsquo;t let it get
            your guard down. You never know if there could be some kind of
            danger lurking around. We will be looking over enemy threats and
            more in a future Discovery Log.
          </p>
          <br />
          <p>
            Thank you for tuning into this week's Discovery Log, we hope you
            look forward to exploring the Overworld and other levels to come! We
            will showcase more levels in upcoming Discovery Logs, make sure to
            be on the lookout for those! Until then, take care everyone!
          </p>
          <p></p>
          <br />- Particle Interactive
        </div>
      </div>
    </div>
  );
});

export default DevLog2;
